var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenThumbUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.5H2.5V4L6 0.5L6.625 1.125C6.68333 1.18333 6.73125 1.2625 6.76875 1.3625C6.80625 1.4625 6.825 1.55833 6.825 1.65V1.825L6.275 4H9.5C9.76667 4 10 4.1 10.2 4.3C10.4 4.5 10.5 4.73333 10.5 5V6C10.5 6.05833 10.4917 6.12083 10.475 6.1875C10.4583 6.25417 10.4417 6.31667 10.425 6.375L8.925 9.9C8.85 10.0667 8.725 10.2083 8.55 10.325C8.375 10.4417 8.19167 10.5 8 10.5ZM3.5 9.5H8L9.5 6V5H5L5.675 2.25L3.5 4.425V9.5ZM2.5 4V5H1V9.5H2.5V10.5H0V4H2.5Z",
    fill: "#34A853"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenThumbUp);
export default __webpack_public_path__ + "static/media/Green_thumb_up.c9cf3b5c52f8bfdc2d0951da9ace86b0.svg";
export { ForwardRef as ReactComponent };